import { Component, ViewChild, Input } from '@angular/core';
import { NavController, NavParams, ModalController, LoadingController } from 'ionic-angular';
import moment from 'moment';
import { CoReserveTimelineComponent } from '../../components/co-reserve-timeline/co-reserve-timeline';
import { CoReserveCalendarComponent } from '../../components/co-reserve-calendar/co-reserve-calendar';
import { PopoverController } from 'ionic-angular/components/popover/popover-controller';
import { AppState } from '../../config/state';
import { CoCartPage } from '../../pages/co-cart/co-cart';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';

@Component({
  selector: 'co-reserve-room-details',
  templateUrl: 'co-reserve-room-details.html',
  inputs: ['isCostEnabled']
})
export class CoReserveRoomDetailsComponent {
  @Input("isCostEnabled") isCostEnabled;
  room: any;
  currentDay: any;
  previousPage: any;
  allLocations: any;
  roomLocation: any;
  didGetLocation: boolean = false;
  showRoomDetails: boolean = false;
  chosenAssets: any = {};
  chosenLayout: any;
  assetTotalCost: number = 0;
  reserveStartTime: any;
  reserveEndTime: any;
  readyToBook: boolean = false;
  reservationLengthHour: any = 0;
  reservationLengthMinutes: any = 0;
  currentCart: any = [];
  viewType: any;
  currentTab: string = 'booker';
  time: any;
  @ViewChild(CoReserveTimelineComponent) innerTimeline: CoReserveTimelineComponent

  constructor(public navCtrl: NavController, public navParams: NavParams, public popoverCtrl: PopoverController, public state: AppState, public modalCtrl: ModalController, private toast : ToastAlertsProvider) {
    this.room = this.navParams.data.room;
    this.currentDay = this.navParams.data.currentDay;
    this.previousPage = this.navParams.data.previousView;
    this.roomLocation = "SOLON";
    this.viewType = this.state.mode;
    this.room.assets.forEach((asset) => {
      this.chosenAssets[asset] = false;
    });
    this.displayTime();
  }

  displayTime() {
    this.time = moment();
    setInterval(() => {
      this.time = moment();
    }, 60000);
  }

  goBack() {
    this.navCtrl.pop();
  }

  nextDay() {
    this.currentDay = moment(this.currentDay).add(1, 'day').format("YYYY-MM-DD HH:mm:ss");
    this.previousPage.setCurrentDate(this.currentDay);
    this.innerTimeline.initializeTimeline();
    this.innerTimeline.resetTimeline();
    this.reserveStartTime = undefined;
    this.reserveEndTime = undefined;
    this.checkReadyToBook();
  }

  previousDay() {
    this.currentDay = moment(this.currentDay).subtract(1, 'day').format("YYYY-MM-DD HH:mm:ss");
    this.previousPage.setCurrentDate(this.currentDay);
    this.innerTimeline.initializeTimeline();
    this.innerTimeline.resetTimeline();
    this.reserveStartTime = undefined;
    this.reserveEndTime = undefined;
    this.checkReadyToBook();
  }

  getCurrentLocation(room, locations) {
    let currentLocation;
    currentLocation = locations.filter((location) => {
      return room.locationId === location.id;
    });
    this.didGetLocation = true;
    return currentLocation[0];
  }

  roomMaxCapacity() {
    return Math.max(this.room.capacityChairs, this.room.capacityStanding, this.room.capacityTables);
  };

  toggleRoomDetails() {
    // document.getElementById("roomDetails").classList.toggle("hidden");
    if (this.showRoomDetails) {
      this.showRoomDetails = false;
    }
    else {
      this.showRoomDetails = true;
    }
  };

  onChange(event, cost) {
    if (event.value) {
      this.assetTotalCost += cost;
    } else if (!event.value) {
      this.assetTotalCost -= cost;
    } else {
    }
  }

  async addToBasket() {
    await this.navCtrl.pop();
    this.addItemToBasket(false);
  }

  async reserveNow() {
    // await this.navCtrl.pop();
    await this.addItemToBasket(true);
    await this.goToCart('', true);
  }

  async addItemToBasket(checkout) {
    let newItem: any = {};
    if (await !this.checkReadyToBook()) {
      return;
    }
    newItem.room = this.room;
    newItem.reserveStartTime = this.reserveStartTime;
    newItem.reserveEndTime = this.reserveEndTime;
    newItem.assetTotalCost = this.assetTotalCost;
    newItem.chosenAssets = [];
    newItem.roomLocation = this.roomLocation;
    newItem.totalPrice = this.assetTotalCost + ((10 * this.reservationLengthHour));
    newItem.reservationPrice = (10 * this.reservationLengthHour);
    newItem.reservationLength = this.buildReservationLengthString(this.reserveStartTime, this.reserveEndTime);
    this.room.assets.forEach((element) => {
      if (this.chosenAssets[element.id]) {
        element.cost = 5;
        newItem.chosenAssets.push(element);
      }
    });

    if (this.room.layouts.length > 0) {
      newItem.chosenLayout = this.chosenLayout;
    }

    if (!checkout) {
      this.toast.triggerToast("Reservation added to cart!", '');
    }
    this.addToCart(newItem);
  }

  updateTimes(times) {
    this.reserveStartTime = times[0];
    this.reserveEndTime = times[1];
    this.reservationLengthHour = moment(times[1]).diff(times[0], "hours");
    this.reservationLengthMinutes = moment(times[1]).diff(times[0], "minutes") - (this.reservationLengthHour * 60);
    if (this.reservationLengthHour === 0) {
      this.reservationLengthHour = 1;
    }

    this.checkReadyToBook();
  }

  openCalendar(event) {
    let popover = this.popoverCtrl.create(CoReserveCalendarComponent, { reservePage: this, currentDay: this.currentDay }, { cssClass: 'reserve-calendar-popover' });
    popover.present({
      ev: event
    });
  }

  goToDate(date) {
    this.currentDay = date;
    this.currentDay = moment(date).format("YYYY-MM-DD HH:mm:ss");
    this.previousPage.setCurrentDate(this.currentDay);
    this.innerTimeline.initializeTimeline();
    this.innerTimeline.resetTimeline();
  }

  checkReadyToBook() {
    if (this.reserveStartTime && this.reserveEndTime) {
      if (this.room.layouts.length > 0 && !this.chosenLayout) {
        this.readyToBook = false;
        return false;
      }
      this.readyToBook = true;
      return true;
    }
    else {
      this.readyToBook = false;
      return false;
    }
  }

  changeLayout(layout) {
    this.chosenLayout = layout;
    this.checkReadyToBook();
  }

  buildReservationLengthString(startTime, endTime) {
    let hour, minute;

    hour = moment(endTime).diff(startTime, "hours");
    minute = moment(endTime).diff(startTime, "minutes");
    if (hour > 0) {
      minute = minute - (hour * 60);
    }

    let finalString: string = "";

    if (hour === 1) {
      finalString = "1 hour";
    }
    else if (hour > 1) {
      finalString = `${hour} hours`;
    }

    if (minute === 1) {
      if (finalString === "") {
        finalString = "1 minute";
      }
      else {
        finalString += " 1 minute";
      }
    }
    else if (minute > 1) {
      if (finalString === "") {
        finalString = `${minute} minutes`;
      }
      else {
        finalString += ` ${minute} minutes`;
      }
    }
    this.reservationLengthHour = hour;
    return finalString;
  }

  goToCart(event, checkout: boolean) {
    let self = this;
    let modal = this.modalCtrl.create(CoCartPage, { currentCart: this.currentCart, clientKeyword: "cuyahogademo", previousPage: this, viewingCart: true, popover: false });
    modal.onDidDismiss(() => {
      self.emptyCartUserClose();
    });
    modal.present();
  }

  addToCart(booking) {
    this.currentCart.push(booking);
  }

  emptyCartUserClose() {
    this.currentCart = [];
  }

  emptyCart() {
    this.currentCart = [];
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/components/co-reserve-room-details/co-reserve-room-details.ts